import type {
  ContactMergeCandidateSearch,
  ContactMergeEditorPayload,
  ContactMergeRecognition,
  ContactMergeTaskDetail,
} from "../types";

/** 从任务详情恢复编辑器载荷。 */
export function toContactMergeEditorPayload(
  detail: ContactMergeTaskDetail,
): ContactMergeEditorPayload {
  return {
    targetContactId: detail.target.contactId,
    sourceContactIds: detail.sources.map((item) => item.contactId),
    primarySalesUserId: detail.fieldResolution.primarySalesUserId,
    fieldResolution: Object.fromEntries(
      Object.entries(detail.fieldResolution.choices ?? {}).map(([key, value]) => [
        toFrontendField(key),
        value,
      ]),
    ),
    fieldCustomValues: detail.fieldResolution.customValues,
  };
}

/** 从识别结果分别提取候选学校和联系人姓名。 */
export function recognitionSearchKeyword(
  recognition: ContactMergeRecognition,
): ContactMergeCandidateSearch {
  const schoolName = recognition.schoolName?.trim() || undefined;
  const contactName = recognition.contactNames[0]?.trim() || undefined;
  return {
    ...(schoolName ? { schoolName } : {}),
    ...(contactName ? { contactName } : {}),
  };
}

/** 返回动作按钮中文文案。 */
export function contactMergeActionLabel(action: string): string {
  return (
    {
      preview: "生成影响预览",
      submit_review: "提交审核",
      approve: "审核通过",
      reject: "驳回",
      execute: "执行合并",
      execute_direct: "一键执行合并",
      retry: "重试",
      resolve_exception: "处理异常",
      cancel: "取消任务",
      view_audit: "查看审计",
    }[action] ?? action
  );
}

/** 将后端字段键转换为前端字段键。 */
function toFrontendField(field: string): string {
  return (
    {
      weixin_code: "weixinCode",
      college_department_major_id: "collegeDepartmentMajorId",
      depart_major_name: "departMajorName",
    }[field] ?? field
  );
}
